document.addEventListener('DOMContentLoaded', function () {
  // const genderSelect = document.querySelector('select[name="options[Womens or Mens]"]');
  // const sizeSelect = document.querySelector('select[name="options[Boot Sizes]"]');
  // if (!genderSelect || !sizeSelect) return;

  // function parseSize(value) {
  //   const parts = value.trim().split(' ');
  //   let base = parseFloat(parts[0]);
  //   if (parts.length === 2 && parts[1] === '1/2') {
  //     base += 0.5;
  //   }
  //   return base;
  // }

  // function sortSizes() {
  //   const sizeData = Array.from(sizeSelect.options).map(option => {
  //     return {
  //       value: option.value,
  //       label: option.text,
  //       numeric: parseSize(option.value),
  //       selected: option.selected
  //     };
  //   });

  //   sizeData.sort((a, b) => a.numeric - b.numeric);

  //   sizeSelect.innerHTML = '';
  //   sizeData.forEach(data => {
  //     const option = document.createElement('option');
  //     option.value = data.value;
  //     option.textContent = data.label;
  //     if (data.selected) option.selected = true;
  //     sizeSelect.appendChild(option);
  //   });

  //   // Re-enable after sorting
  //   sizeSelect.style.visibility = 'visible'
  // }

  // function delayedSort() {
  //   // Disable while waiting
  //   sizeSelect.style.visibility = 'hidden';

  //   // Wait for Shopify to finish updating, then sort
  //   setTimeout(sortSizes, 1500); // adjust delay if needed
  // }

  // genderSelect.addEventListener('change', delayedSort);
  // delayedSort(); // initial sort
});
